import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

import styles from './styles.module.scss';

const Pseudolink = ({ title, theme, ...props }) => {
	const pseudolinkCx = cx(styles.pseudolink, styles[`theme_${theme}`]);

	return (
		<button
			type="button"
			className={pseudolinkCx}
			aria-label={title}
			{...props}
		>
			{title}
		</button>
	);
};

Pseudolink.propTypes = {
	title: PropTypes.string.isRequired,
	theme: PropTypes.oneOf(['colored']),
	onClick: PropTypes.func
};

export default Pseudolink;
